import RentalProductListPage from '@/views/restricted/rentalModule/acquisition/RentalProductListPage.vue'
import DistributorLayout from '@/layouts/DistributorLayout.vue'
import RentalProductDetailPage from '@/views/restricted/rentalModule/acquisition/RentalProductDetailPage.vue'
import RentalFileCreatePage from '@/views/restricted/rentalModule/acquisition/RentalFileCreatePage.vue'
import RentalFileDetailPage from '@/views/restricted/rentalModule/rentalFile/RentalFileDetailPage.vue'
import RentalFileAddPicturePage from '@/views/public-access/rentalModule/RentalFileAddPicturePage.vue'

export default [
  {
    path: '/rental-module/product-list/:repairFileBoomerangId',
    name: 'RentalProductListPage',
    menuSelected: 'rentalModule',
    component: RentalProductListPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_RENTAL_CREATE']
    }
  },
  {
    path: '/rental-module/product-detail/:rentalProductId',
    name: 'RentalProductDetailPage',
    menuSelected: 'rentalModule',
    component: RentalProductDetailPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_RENTAL_CREATE']
    }
  },
  {
    path: '/rental-module/rental-file-create/:rentalProductId',
    name: 'RentalFileCreatePage',
    menuSelected: 'rentalModule',
    component: RentalFileCreatePage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_RENTAL_CREATE']
    }
  },
  {
    path: '/rental-module/rental-file-detail/:rentalFileId',
    name: 'RentalFileDetailPage',
    menuSelected: 'rentalModule',
    component: RentalFileDetailPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_RENTAL_READ']
    }
  },
  {
    path: '/public/rental-module/add-product-picture',
    name: 'RentalFileAddPicturePage',
    component: RentalFileAddPicturePage,
    meta: {
      requiresAuth: false
    }
  }
]
